<div class="campaigns-grid">
  <article class="campaign-card" *ngFor="let campanha of campanhas"
    (click)="callRouteDetalheCampanha(campanha?.campanha?.id, campanha?.campanha?.titulo)">
    <!-- Card Media / Badges -->
    <div class="campaign-card-img">
      <img [src]="campanha?.imgPreview || campanha?.campanha?.fotoUrl || '/images/campanha-1.png'"
        [alt]="campanha?.campanha?.titulo || 'Imagem da campanha'" loading="lazy" />
      <div class="campaign-card-badges">
        <div class="cc-badges-left">
          <span class="cc-badge-cat">
            <i [class]="getCategoryIcon(campanha?.campanha?.categoria?.descricao)"></i>
            {{ campanha?.campanha?.categoria?.descricao || 'Causa Social' }}
          </span>
          <span class="cc-badge-type" *ngIf="campanha?.campanha?.tipoFinanciamento || campanha?.campanha?.tipoFinanciamentoENUM">
            <i [class]="getTipoFinanciamentoIcon(campanha?.campanha?.tipoFinanciamentoENUM || campanha?.campanha?.tipoFinanciamento)"></i>
            {{ campanha?.campanha?.tipoFinanciamento || getTipoFinanciamentoLabel(campanha?.campanha?.tipoFinanciamentoENUM) }}
          </span>
        </div>
        <span class="cc-badge-days" [ngClass]="getDaysClass(campanha?.campanha?.diasRestantes || 0)"
          *ngIf="!campanha?.campanha?.expirado">
          <i class="fas fa-clock"></i>
          {{ campanha?.campanha?.diasRestantes || 0 }} dias
        </span>
        <span class="cc-badge-days urgent" *ngIf="campanha?.campanha?.expirado">
          <i class="fas fa-clock"></i> Encerrada
        </span>
      </div>
      <span class="cc-badge-featured">
        <i class="fas fa-fire"></i> Em Destaque
      </span>
    </div>

    <!-- Card Body -->
    <div class="campaign-card-body">
      <h3 class="campaign-card-title">{{ campanha?.campanha?.titulo }}</h3>

      <div class="campaign-card-org">
        <i class="fas fa-circle-check"></i>
        <span>{{ campanha?.campanha?.utilizadorNome || 'Autor não informado' }} · {{
          campanha?.campanha?.provincia?.descricao || 'Luanda' }}</span>
      </div>

      <p class="campaign-card-desc line-clamp-2">
        {{ campanha?.campanha?.descricaoCurta || campanha?.campanha?.descricao || 'Sem descrição informada para esta
        campanha.' }}
      </p>

      <!-- Progress Section -->
      <div class="campaign-card-progress">
        <div class="cc-progress-top">
          <span class="cc-amount">{{ formatShortNum(campanha?.campanha?.valorArrecado) }}</span>
          <span class="cc-pct-badge" [ngClass]="getPctClass(getPercent(campanha?.campanha))">
            {{ getPercent(campanha?.campanha) }}%
          </span>
        </div>

        <div class="cc-progress-bar">
          <div class="cc-progress-fill" [ngClass]="getPctClass(getPercent(campanha?.campanha))"
            [style.width.%]="getPercent(campanha?.campanha) > 100 ? 100 : (getPercent(campanha?.campanha) < 0.5 && getPercent(campanha?.campanha) > 0 ? 1 : getPercent(campanha?.campanha))">
          </div>
        </div>

        <div class="cc-meta">
          <div class="cc-meta-item">
            <i class="fas fa-users"></i>
            <span>{{ campanha?.campanha?.totalDoadores || 0 }} doadores</span>
          </div>
          <div class="cc-meta-item"
            [class.urgent]="(campanha?.campanha?.diasRestantes || 0) <= 10 && !campanha?.campanha?.expirado">
            <i class="fas fa-clock"></i>
            <span *ngIf="!campanha?.campanha?.expirado">{{ campanha?.campanha?.diasRestantes || 0 }} dias
              restantes</span>
            <span *ngIf="campanha?.campanha?.expirado">Encerrada</span>
          </div>
          <div class="cc-meta-item">
            <i class="fas fa-bullseye"></i>
            <span>{{ formatShortNum(campanha?.campanha?.metaArrecadar) }} meta</span>
          </div>
        </div>
      </div>

      <!-- Action Button -->
      <button type="button" class="btn btn-primary btn-full btn-rounded" style="margin-top: auto;"
        (click)="callRouteFinacy(campanha?.campanha?.id, campanha?.campanha?.titulo, $event)"
        *ngIf="!campanha?.campanha?.expirado && (campanha?.campanha?.EstadoCampanhaENUM === 4 || campanha?.campanha?.estadoCampanhaENUM === 4 || !campanha?.campanha?.estadoCampanhaENUM)">
        <i class="fas fa-heart"></i>
        <span>Financiar Projecto</span>
      </button>
    </div>

    <!-- Reactions Component (Card Footer) -->
    <app-reactions [campanhaID]="campanha?.campanha?.id" [curtidaID]="campanha?.campanha?.curtidas?.curtidasId"
      [totalCurtidas]="campanha?.campanha?.curtidas?.totalCurtidas || 0"
      [totalComentarios]="campanha?.campanha?.totalComentarios || campanha?.campanha?.comentarios?.length || 0"
      [campanhaTitulo]="campanha?.campanha?.titulo"
      (commentAdded)="onCommentAdded(campanha?.campanha)"></app-reactions>
  </article>
</div>